<script setup>
import { computed, onMounted } from 'vue'

const props = defineProps({
    selectedItems: {
        type: Set,
        required: true
    },
    itemType: {
        type: String,
        default: 'Project'
    },
    isExporting: {
        type: Boolean,
        default: false
    },
    isDeleting: {
        type: Boolean,
        default: false
    },
    showExport: {
        type: Boolean,
        default: false
    },
    disabledPin: {
        type: Function,
        default: () => ({ pin: false, unpin: false })
    }
})

onMounted(async () => {
    console.log('>props.disabledPin>>>>>', props.disabledPin)
}) 


const emit = defineEmits([
    'clear-selection',
    'bulk-export',
    'bulk-pin',
    'bulk-delete',
    'add-to-list',
    'create-list'
])

const itemCount = computed(() => props.selectedItems.size)

const itemText = computed(() => {
    return itemCount.value === 1 ? props.itemType : `${props.itemType}s`
})

const handleClearSelection = () => {
    emit('clear-selection')
}

const handleBulkExport = () => {
    emit('bulk-export')
}

const handlePin = (status) => {
    emit('bulk-pin', status)
}

const handleBulkDelete = () => {
    emit('bulk-delete')
}

const handleAddToList = () => {
    emit('add-to-list')
}

const handleCreateList = () => {
    emit('create-list')
}

const isPinDisabled = (action) => {
    return props.disabledPin(action)
}
</script>

<template>
    <div
        v-if="itemCount > 0"
        class="bulk-actions-footer text-center"
    >
        <div class="footer-content">
            <div class="selection-chip">
                <span class="selection-count">
                    {{ itemCount }} {{ itemText }} selected
                </span>
                <button
                    class="clear-btn"
                    @click="handleClearSelection"
                >
                    <img
                        src="@/assets/img/cancel-01.png"
                        style="width: 20px; cursor: pointer"
                        alt=""
                    />
                </button>
            </div>
            <div class="action-buttons">
                <button
                    v-if="showExport"
                    class="action-btn"
                    @click="handleBulkExport"
                    :disabled="isExporting"
                >
                    <img
                        v-if="!isExporting"
                        src="@/assets/img/import.png"
                        style="width: 20px; cursor: pointer"
                        alt=""
                    />
                    <div
                        v-else
                        class="spinner-border spinner-border-sm me-2"
                        role="status"
                        style="width: 20px; height: 20px"
                    >
                        <span class="visually-hidden">
                            Loading...
                        </span>
                    </div>
                    <span>
                        {{ isExporting ? "Downloading..." : "Download" }}
                    </span>
                </button>
                <button
                    class="action-btn"
                    @click="handlePin(1)"
                    :disabled="isPinDisabled('pin').pin"
                >
                    <img
                        src="@/assets/img/pin-active.png"
                        style="width: 20px; cursor: pointer"
                        alt=""
                    />
                    <span>Pin</span>
                </button>
                <button
                    class="action-btn"
                    @click="handlePin(0)"
                    :disabled="isPinDisabled('unpin').unpin"
                >
                    <img
                        src="@/assets/img/pin1.png"
                        style="width: 20px; cursor: pointer"
                        alt=""
                    />
                    <span style="color: darkred">Unpin</span>
                </button>
                <button
                    class="action-btn"
                    @click="handleBulkDelete"
                    :disabled="isDeleting"
                >
                    <img
                        v-if="!isDeleting"
                        src="@/assets/img/delete-table.png"
                        style="width: 20px; cursor: pointer"
                        alt=""
                    />
                    <div
                        v-else
                        class="spinner-border spinner-border-sm me-2"
                        role="status"
                        style="width: 20px; height: 20px"
                    >
                        <span class="visually-hidden">
                            Loading...
                        </span>
                    </div>
                    <span>
                        {{ isDeleting ? "Deleting..." : "Delete" }}
                    </span>
                </button>
                <button
                    class="action-btn"
                    @click="handleAddToList"
                >
                    <img
                        src="@/assets/img/add.png"
                        style="width: 20px; cursor: pointer"
                        alt=""
                    />
                    <span>Add to List</span>
                </button>
                <button
                    class="action-btn"
                    @click="handleCreateList"
                >
                    <img
                        src="@/assets/img/menu-01.png"
                        style="width: 20px; cursor: pointer"
                        alt=""
                    />
                    <span>Create a new list</span>
                </button>
            </div>
        </div>
    </div>
</template>

<style scoped>
.bulk-actions-footer {
    background-color: #fff;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    padding: 10px;
    z-index: 100;
    position: fixed !important;
    bottom: 30px !important;
    margin: 0 auto;
    left: 50%;
    transform: translateX(-50%);
    width: fit-content;
    max-width: 1200px;

}

.footer-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 1200px;
    margin: 0 auto;
}

.selection-chip {
    display: flex;
    align-items: center;
    background-color: #f0f0f0;
    padding: 6px 12px;
    border-radius: 20px;
}

.selection-count {
    font-weight: 500;
    margin-right: 8px;
}

.clear-btn {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
}

.action-buttons {
    display: flex;
    gap: 10px;
}

.action-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    background: none;
    border: none;
    padding: 8px 12px;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.2s;
}

.action-btn:hover {
    background-color: #f0f0f0;
}

/* Ensure disabled action buttons don't show pointer cursor */
.action-btn:disabled {
    cursor: not-allowed;
}

.action-btn:disabled img,
.action-btn:disabled span {
    cursor: not-allowed !important;
}
</style>
